<template>
  <div>
    <Alert type="error" v-if="errorMsg">{{ errorMsg }}</Alert>
    <div v-else>
      <Spin fix v-if="infoLoading"></Spin>
      <p>
        <icon type="iconfont icon-volume" class="icon-iconfont" color="#999" style="margin-right: 6px" size="16"></icon>
        <a v-on:click="openRuleView" style="font-size: 13px">{{ volumeInfo.name }}</a>
        <Badge v-if="volumeInfo.status" :status="volumeStatusTransfer(volumeInfo.status).color" style="margin-left: 10px"></Badge>
      </p>
      <div style="margin-left: 22px; color: #999">
        <p>
          <span>{{ volumeInfo['os-vol-host-attr:host'] }}</span>
        </p>
        <p>
          <span>{{ volumeInfo.size }} GB</span>
        </p>
        <p v-for="item in volumeInfo.attachments" :key="item.attachment_id">
          <span>{{ item.device }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { detailPrivateCloudVolume } from '@/api/private-cloud/volume'
import { statusTransfer } from '@/view/private-cloud/storage/volume_status_transfer'

export default {
  name: 'server-volume-info',
  props: {
    volumeId: {
      type: String
    }
  },
  data () {
    return {
      volumeInfo: {},
      infoLoading: false,
      errorMsg: null
    }
  },
  created: function () {
    this.getVolume()
  },
  methods: {
    getVolume () {
      this.infoLoading = true
      detailPrivateCloudVolume(this.volumeId).then(res => {
        this.volumeInfo = res.data.volume
        this.errorMsg = null
        this.infoLoading = false
      }).catch(res => {
        this.infoLoading = false
        this.errorMsg = res.response.data
      })
    },
    volumeStatusTransfer (status) {
      return statusTransfer(status)
    },
    openRuleView () {
      this.$router.push({ name: 'volume_detail', params: { id: this.volumeInfo.id } })
    }
  }
}
</script>

<style scoped>

</style>
